import type { AiSuggestionsPluginOptions } from '@atlassian/editor-plugin-ai-suggestions';

interface Props {
	options: AiSuggestionsPluginOptions;
}

export function aiSuggestionsOptions({ options }: Props): AiSuggestionsPluginOptions {
	return options;
}
